module.exports = __webpack_public_path__ + "assets/img/logobk.9926836e.png";